import { Snackbar } from '@varlet/ui';

const toast = {
  success: Snackbar.success,
  warning: Snackbar.warning,
  info: Snackbar.info,
  error: Snackbar.error,
  loading: Snackbar.loading,
} as const;

export { toast };
